import { render, staticRenderFns } from "./CreateServiceLogs.vue?vue&type=template&id=1783fd46"
import script from "./CreateServiceLogs.vue?vue&type=script&lang=js"
export * from "./CreateServiceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports